import React from "react";
import PropTypes from "prop-types";
import {errorMessage, isInvalid} from "./Component";


const CheckboxGroup = (props) => {

  return (
    <div
      className={"checkbox-group" + (props.formField.error ? " is-invalid" : "")}>
      <span>
        {props.children}
      </span>
      <span className="flex-grow-1 "></span>
      {isInvalid(props) &&
          <span className="error-icon fz fz-exclamation-triangle solid">
            <div className="has-tooltip danger"
                 data-tooltip={errorMessage(props)}/>
          </span>
      }
    </div>
  )
}

export default CheckboxGroup;

CheckboxGroup.propTypes = {
  formField: PropTypes.object.isRequired,
}
